import { Component } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { CartItem } from '@app/_interfaces/cart-item';
import { AuthenticationService } from '@app/_services';
import { QuotationCartService } from '@app/_services/quotation.service';
import { Address } from '@interfaces/address';
import { Order } from '@interfaces/order';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { addresses } from 'src/data/account-addresses';
import { orders } from 'src/data/account-orders';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { VendorQuotationComponent } from './quotation-vendor/quotation-vendor.component';
import { NgIf, NgFor } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';
interface Item {
    cartItem: CartItem;
    quantity: number;
    quantityControl: UntypedFormControl;
}
@Component({
    selector: 'app-quotation-requests',
    templateUrl: './quotation-requests.component.html',
    styleUrls: ['./quotation-requests.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        NgFor,
        VendorQuotationComponent,
        TranslateModule,
    ],
})
export class QuotationRequestsComponent {
    constructor(
        private authService: AuthenticationService,
        public quotationCart: QuotationCartService,
        private toastr: ToastrService,
        private router:Router
    ) { }

    updating = false;
    public loading = false;

    remove(item): void {
        let params: any = {};
        params = {
            itemId: item.itemId,
            amount: 0,
        };
        this.quotationCart.updateCartItem(params).subscribe();
    }

    updateValue(quantity, itemId) {
        this.loading = true;
        let params: any = {};
        params = {
            itemId: itemId,
            amount: quantity,
        };
        this.quotationCart.updateCartItem(params).subscribe((response) => {
            this.loading = false;
        });
    }

    clearCart() {
        this.updating = true;
        this.quotationCart.clearCart().subscribe(
            (response) => {
                this.router.navigate(['/account/active-quotations']);
                this.toastr.success(response.msg);
            },
            (error) => { }
        );
    }

    ///show quotation carts if there are carts in data
    showCarts() {
        return _.isEmpty(this.quotationCart.cartItems);
    }
}
